import { loginObj, validateError } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var appApisGTW = null;
appApisGTW = axios.create({
  baseURL: process.env.VUE_APP_API_GTW
});
setupInterceptors(appApisGTW);
export default {
  getAllLineage: function getAllLineage() {
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/data-lineage/data-lineage-catalog/objecttype/table/objectid/all").then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  },
  getLineage: function getLineage(type, id) {
    tasks.lockScreen.lock();
    return appApisGTW.get("/api/v1/data-lineage/data-lineage-detail/objecttype/" + type + "/objectid/" + id).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    });
  }
};